import { roundToDecimal } from './decimals'

const guessBodyTempUnits = value => (value < 50 ? '°C' : '°F')

const convertCelsiusToFahrenheit = celsius =>
  roundToDecimal(celsius * (9 / 5) + 32, 1)

const convertFahrenheitToCelsius = (fahrenheit, precision = 1) =>
  roundToDecimal((fahrenheit - 32) * (5 / 9), precision)

/**
 * This is the the function we always want to use when storing a temperature to
 * the case data.
 *
 * If it is given in fahrenheit, it will be converted to celsius with 2 decimal
 * places of precision this ensures that it is stored with enough precision to
 * be converted back to the same one decimal of precision value if we are going
 * back to fahrenheit.
 *
 * @param {number} unknownValueType
 * @returns {number}
 */
export const coerceToCelsiusForStorage = unknownValueType =>
  guessBodyTempUnits(unknownValueType) === '°F'
    ? convertFahrenheitToCelsius(unknownValueType, 2)
    : unknownValueType

/**
 * @param {number} valueFromCaseData
 * @param {TempUnit} targetUnit
 * @returns {number}
 */
export const displayTemperature = (valueFromCaseData, targetUnit) => {
  // If the value is greater than 50, we assume it got saved
  // as fahrenheit so if we are trying to display as fahrenheit
  // just return it.
  const wasStoredInFahrenheit = guessBodyTempUnits(valueFromCaseData) === '°F'
  if (wasStoredInFahrenheit) {
    if (targetUnit === 'F') {
      return valueFromCaseData
    }
    return convertFahrenheitToCelsius(valueFromCaseData)
  }

  // if the value is less than 50, we assume it got saved as celsius
  if (targetUnit === 'F') {
    return convertCelsiusToFahrenheit(valueFromCaseData)
  }
  if (targetUnit === 'C') {
    return roundToDecimal(valueFromCaseData, 1)
  }
}
